LhApp = LhApp || {};

LhApp.Function = {};

LhApp.Function.Url = {};
LhApp.Function.QueryString = {};
LhApp.Function.String = {};
LhApp.Function.Tracking = {};
LhApp.Function.Actions = {};


LhApp.Function.Actions.ActionsType = { ORDER_COMPLETION: 0 };
LhApp.Function.Actions.StorageType = { SESSION: 0, PERSISTENT: 1, CROSS_TABS_SESSION: 2 }; /* CROSS_TABS_SESSION : currently unsupported - custom implementation */
LhApp.Function.Actions.Counter = function (actionsType, storageType, actionIdentifier) {
    var storekey = 'Vendd:Actions.Counter';
    var storage = storageType == LhApp.Function.Actions.ActionsType.PERSISTENT ? localStorage : sessionStorage;
    var action = actionsType + (actionIdentifier ? ':' + actionIdentifier : actionIdentifier);

    this.getCount = function () {
        var store = JSON.parse(storage.getItem(storekey)) || {};
        return parseInt(store[action] || 0);
    }
    this.increment = function () {
        var store = JSON.parse(storage.getItem(storekey)) || {};
        store[action] = (parseInt(store[action]) || 0) + 1;
        storage.setItem(storekey, JSON.stringify(store));
    }
    this.reset = function () {
        var store = JSON.parse(storage.getItem(storekey)) || {};
        store[action] = undefined;
        storage.setItem(storekey, JSON.stringify(store));
    }
}

LhApp.Function.Tracking.updateTrackingData = function (updateData) {
    window.TrackingData = $.extend(true, {}, window.TrackingData, updateData);
}

//custom ga in
LhApp.Function.Tracking.ga = function () {

    if (!LhApp.Function.Tracking.canTrack('statisticCookies'))
        return false;

    if (!LhApp.Function.Tracking.InitGoogleAnalytics())
        return false;

    if (typeof (ga) == 'undefined')
        return false;

    ga.apply(null, arguments);

    return true;
}

LhApp.Function.Tracking.canTrack = function (cookieType) {
    if (cookieType === "necessaryCookies")
        return true;

    var Consents = (typeof (ConsentsManager) != "undefined" && ConsentsManager) || (typeof (CheckoutConsentsManager) != "undefined" && CheckoutConsentsManager);
    if (!Consents)
        return false;

    if (!cookieType)
        cookieType = 'marketingCookies';

    if (Consents.cookiesStatus[cookieType] === undefined)
        return false;

    if (!LhApp.Context.IsConsentsEnabled)
        return true;

    return Consents.cookiesStatus[cookieType];
}

LhApp.Function.Tracking.getTrackingModel = function () {
    var trackingModel = window.TrackingData;
    if (!trackingModel || !trackingModel.IsTrackingEnabled)
        return null;

    return JSON.parse(JSON.stringify(trackingModel));//retunr cloned object
}

LhApp.Function.Tracking.getTracker = function (trackerCode, trackingModel) {    
    if (!trackingModel || !trackingModel.IsTrackingEnabled)
        return null;

    var tracker = trackingModel.Trackers[trackerCode.toLowerCase()]; // if available than IsActive = 1 in DB
    if (!tracker)
        return null;

    if (!tracker.Properties)
        return null;

    return tracker;
}

LhApp.Function.Tracking.getFeedItemId = function (product, datasource, tracker) {    
    if (product.FeedCodes && product.FeedCodes[tracker.FeedCodeField])
        return product.FeedCodes[tracker.FeedCodeField];

    var productId, colorId, sizeId, dim3Id, dim4Id, dim5Id, dim6Id, merchantId;

    if (datasource == 'ProductChanged') {
        productId = product.ParentProductId;

        var colors = product.Dimensions.find(function (i) { return i.IsColor });
        var sizes = product.Dimensions.find(function (i) { return i.IsSize });
        var dim3s = product.Dimensions.find(function (i) { return i.IsDim3 });
        var dim4s = product.Dimensions.find(function (i) { return i.IsDim4 });
        var dim5s = product.Dimensions.find(function (i) { return i.IsDim5 });
        var dim6s = product.Dimensions.find(function (i) { return i.IsDim6 });
        var merchants = product.Dimensions.find(function (i) { return i.IsMerchant });

        var color = colors && colors.Versions.find(function (i) { return i.ProductId == product.SelectedProductId })
        var size = sizes && sizes.Versions.find(function (i) { return i.ProductId == product.SelectedProductId })
        var dim3 = dim3s && dim3s.Versions.find(function (i) { return i.ProductId == product.SelectedProductId })
        var dim4 = dim4s && dim4s.Versions.find(function (i) { return i.ProductId == product.SelectedProductId })
        var dim5 = dim5s && dim5s.Versions.find(function (i) { return i.ProductId == product.SelectedProductId })
        var dim6 = dim6s && dim6s.Versions.find(function (i) { return i.ProductId == product.SelectedProductId })
        var merchant = merchants && merchants.Versions.find(function (i) { return i.ProductId == product.SelectedProductId })

        colorId = color && color.VersionId;
        sizeId = size && size.VersionId;
        dim3Id = dim3 && dim3.VersionId;
        dim4Id = dim4 && dim4.VersionId;
        dim5Id = dim5 && dim5.VersionId;
        dim6Id = dim6 && dim6.VersionId;
        merchantId = merchant && merchant.VersionId;
    }
    else {
        productId = product.ProductId;

        colorId = product.ColorId;
        sizeId = product.SizeId;
        dim3Id = product.Dim3Id;
        dim4Id = product.Dim4Id;
        dim5Id = product.Dim5Id;
        dim6Id = product.Dim6Id;
        merchantId = product.MerchantId;
    }

    if (colorId && parseInt(colorId) > 0) {
        productId += "-" + colorId;
    }
    if (tracker.SplitFeedBySize && sizeId && parseInt(sizeId) > 0) {
        productId += "-" + sizeId;
    }
    if (tracker.SplitFeedByDim3 && dim3Id && parseInt(dim3Id) > 0) {
        productId += "-" + dim3Id;
    }
    if (tracker.SplitFeedByDim4 && dim4Id && parseInt(dim4Id) > 0) {
        productId += "-" + dim4Id;
    }
    if (tracker.SplitFeedByDim5 && dim5Id && parseInt(dim5Id) > 0) {
        productId += "-" + dim5Id;
    }
    if (tracker.SplitFeedByDim6 && dim6Id && parseInt(dim6Id) > 0) {
        productId += "-" + dim6Id;
    }
    if (tracker.SplitFeedByMerchant && merchantId && parseInt(merchantId) > 0) {
        productId += "-M" + merchantId;
    }

    return productId;
}

//used for tag manager. keep in mind even though can be used for gtag.js vendd does not include gtag.js tags
LhApp.Function.Tracking.gtag = function () {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(arguments);
}

LhApp.Function.Tracking.InitGoogleTagManager = function (tagManagerCode) {

    var trackingModel = LhApp.Function.Tracking.getTrackingModel();

    if (tagManagerCode === undefined) // if not defined tag manager code
    {
        if (!trackingModel || !trackingModel.GoogleTagManagerCode)
            return false;
        tagManagerCode = trackingModel.GoogleTagManagerCode;
    }

    if (!tagManagerCode)
        return false;

    //initialization check
    if (window.googleTagManagerInitialized)
        return true;

    var consentsManager = window.ConsentsManager || window.CheckoutConsentsManager;
    var cookiesStatus = consentsManager && consentsManager.cookiesStatus;

    if (trackingModel.LoadTagManagerWhenConsentsGranted) {
        //if all cookie consents are required to load tag manager
        if (!(cookiesStatus && cookiesStatus.marketingCookies && cookiesStatus.statisticCookies && cookiesStatus.functionalityCookies)){
            return false;
        }
    }

    if (trackingModel.EnableGoogleTagManagerConsents) {
        //init consents before tag manager initiation
        LhApp.Function.Tracking.gtag('consent', 'default', {
            'ad_storage': cookiesStatus && cookiesStatus.marketingCookies ? 'granted' : 'denied',
            'analytics_storage': cookiesStatus && cookiesStatus.statisticCookies ? 'granted' : 'denied',
            'functionality_storage': cookiesStatus && cookiesStatus.functionalityCookies ? 'granted' : 'denied',
            'ad_personalization': cookiesStatus && cookiesStatus.marketingCookies ? 'granted' : 'denied',
            'ad_user_data': cookiesStatus && cookiesStatus.marketingCookies ? 'granted' : 'denied',
            'personalization_storage': cookiesStatus && cookiesStatus.functionalityCookies ? 'granted' : 'denied',
            'security_storage': 'granted'
        });
    }    

    //init tag manager    
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', tagManagerCode);
    //mark tag manager as initialized
    window.googleTagManagerInitialized = true;

    /*--DEPRICATED-- Expose Cookie Consents to Data Layer*/
    var consentsCookie = Cookies.getJSON('ConsentChecked');
    if (consentsCookie) {
        window.dataLayer.push({ 'functionalityCookiesEnabled': consentsCookie.functionalityCookies, 'marketingCookiesEnabled': consentsCookie.marketingCookies, 'statisticCookiesEnabled': consentsCookie.statisticCookies });
    }

    //custom tag manager event when consents are ready (default active or user has set options in a previous page)
    if (cookiesStatus && (consentsManager.cookiesStatus.userHasSetCookies || LhApp.Context.CookiesDefaultActive)) {
        dataLayer.push({ 'event': 'vendd_consents_ready' });
    }

    return true;
}

LhApp.Function.Tracking.InitGoogleAnalytics = function (analyticsCode) {
    if (analyticsCode === undefined) // if not defined
    {
        var trackingModel = LhApp.Function.Tracking.getTrackingModel();
        if (!trackingModel || !trackingModel.GoogleAnalyticsCode)
            return false;
        analyticsCode = trackingModel.GoogleAnalyticsCode;
    }

    if (!analyticsCode)
        return false;

    //initialization check
    if (window.googleAnalyticsInitialized)
        return true;
    window.googleAnalyticsInitialized = true;

    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
            m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

    ga("create", analyticsCode, 'auto');

    return true;
}

LhApp.Function.Url.getServiceEndpoint = function (url) {
    var rewritedUrl = LhApp.Context.Request.BaseUrl + '/services/';

    rewritedUrl += url;

    if (unescape(LhApp.Context.Request.FriendlyUrl).indexOf('?') != -1) {

        var queryString = '';
        var initialQueryString = unescape(LhApp.Context.Request.FriendlyUrl).substring(unescape(LhApp.Context.Request.FriendlyUrl).indexOf('?') + 1);

        var iid = LhApp.Function.QueryString.getValueOf('iid', unescape(LhApp.Context.Request.RawUrl));
        if (iid != '') queryString = 'iid=' + iid;
        else if (LhApp.Context.Item && LhApp.Context.Item.Id)
            queryString = 'iid=' + LhApp.Context.Item.Id;
        if (rewritedUrl.indexOf(initialQueryString) == -1) {

            if (initialQueryString.length > 0) queryString += '&' + initialQueryString;

            if (rewritedUrl.indexOf('?') == -1)
                queryString = '?' + queryString;
            else
                queryString = '&' + queryString;
        }
        rewritedUrl += queryString;
    }

    rewritedUrl = rewritedUrl.replace("?&", "?");
    var domainUrl = rewritedUrl.split('?');
    var qsrt = "";
    if (domainUrl.length > 1) {
    	var q = domainUrl[1];
    	var qArray = q.split('&');
    	var operator = '?';
    	for (i = 0; i < qArray.length; i++) {
    		if (qArray[i] != "" && qArray[i] != "" && qsrt.indexOf(qArray[i]) == -1) {
    			if (i == 0) {
    				operator = '?';
    			} else {
    				operator = '&';
    			}
    			qsrt += operator + qArray[i];
    		}
    	}
    }
    return domainUrl[0] + qsrt;
};

LhApp.Function.QueryString.parse = function (url) {
    var qparams = {},
        parts = (url || '').split('?'),
        qparts, qpart,
        i = 0;

    if (parts.length <= 1) {
        return qparams;
    } else {
        qparts = parts[1].split('&');
        for (i in qparts) {
            qpart = qparts[i].split('=');
            var pName = decodeURIComponent(qpart[0]).toLowerCase();
            var pValue = decodeURIComponent(qpart[1] || '');
            qparams[pName] = pValue;
        }
    }

    return qparams;
};

LhApp.Function.QueryString.getValueOf = function (parameterKey, url) {

    url = url || window.location.href;
    var parameterValue = '';

    var queryString = '';
    var hasQueryString = (url.indexOf('?') > -1);

    if (hasQueryString) {
        queryString = url.substring(url.indexOf('?') + 1);
    }

    var parameters = queryString.split("&");

    if (queryString.indexOf(parameterKey) >= 0) {

        for (var i = 0; i < parameters.length; i++) {
            var pair = parameters[i].split("=");
            if (pair[0] == parameterKey) {
                parameterValue = pair[1];
            }
        }
    }

    return parameterValue;
};

LhApp.Function.Url.setParameterValue = function (parameterKey, parameterValue) {

    var url = window.location.href;

    return this.setParameterValueOnUrl(url, parameterKey, parameterValue);
};

LhApp.Function.Url.setParameterValueOnUrl = function (url, parameterKey, parameterValue) {

    var newUrl;

    var queryString = '';
    var hasQueryString = (url.indexOf('?') > -1);

    if (hasQueryString) {
        queryString = url.substring(url.indexOf('?') + 1);
    }

    var parameters = queryString.split("&");

    if (queryString.indexOf(parameterKey) >= 0) {

        for (var i = 0; i < parameters.length; i++) {
            var pair = parameters[i].split("=");
            if (pair[0] == parameterKey) {
                parameters[i] = pair[0] + "=" + parameterValue;
            }
        }

        queryString = parameters.join("&");

    } else {
        if (hasQueryString) {
            queryString += '&' + parameterKey + '=' + parameterValue;
        } else {
            queryString += '?' + parameterKey + '=' + parameterValue;
        }
    }

    if (hasQueryString) {
        newUrl = url.substring(0, url.indexOf('?') + 1) + queryString;
    } else {
        newUrl = url + queryString;
    }

    return newUrl;
};

LhApp.Function.Url.removeParameter = function (parameterKey) {

    var url = window.location.href;
    var parameterKeys = [parameterKey];

    return this.removeParametersFromUrl(url, parameterKeys);
};

LhApp.Function.Url.removeParameterFromUrl = function (url, parameterKey) {
    var parameterKeys = [parameterKey];

    return this.removeParametersFromUrl(url, parameterKeys);
};

LhApp.Function.Url.removeParameters = function (parameterKeys) {

    var url = window.location.href;

    return this.removeParametersFromUrl(url, parameterKeys);
};

LhApp.Function.Url.removeParametersFromUrl = function (url, parameterKeys) {

    var newUrl = url;

    $.each(parameterKeys, function (index, parameterKey) {

        var queryString = '';
        var hasQueryString = (newUrl.indexOf('?') > -1);

        if (hasQueryString) {
            queryString = newUrl.substring(newUrl.indexOf('?') + 1);

            var parameters = queryString.split("&");

            if (queryString.indexOf(parameterKey) >= 0) {

                for (var i = 0; i < parameters.length; i++) {
                    var pair = parameters[i].split("=");
                    if (pair[0] == parameterKey) {
                        parameters.splice(i, 1);
                    }
                }

                queryString = parameters.join("&");
                if (queryString != "")
                    newUrl = newUrl.substring(0, newUrl.indexOf('?') + 1) + queryString;
                else
                    newUrl = newUrl.substring(0, newUrl.indexOf('?')) + queryString;
            }
        }
    });

    return newUrl;
};

LhApp.Function.getText = function (key) {

    if (typeof LhApp.Text == 'undefined')
        return '';

    var match = LhApp.Text[key];
    if (match === undefined) {
        var resource = LhApp.Function.getTranslatableTextFromServer(key);
        LhApp.Text[key] = resource;
        match = resource;
    }

    return match || '';
};

LhApp.Function.getTranslatableTextFromServer = function (key) {
    var result = key;
    $.ajax({
        async: false,
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=UTF-8',
        ContentType: 'application/json; charset=UTF-8',
        url: LhApp.Function.Url.getServiceEndpoint('commonservice.svc/GetTranslatableResource'),
        data: JSON.stringify({
            key: key
        }),
        success: function (response) {
            result = response.d;
        }
    });

    return result;
};

LhApp.Function.String.isEmail = function(text) {
    var re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}|^$/i;
    return re.test(text);
};

LhApp.Function.String.isAlphaNumeric = function (text) {
    var letterNumber = /^[0-9a-zA-Z]+$/;
    return text.match(letterNumber) || false;
};

LhApp.Function.initVisitorState = function () {

    var cookieValue = Cookies.get("VisitorState");
    if (cookieValue) {

        LhApp.Function.checkAndUpdateVisitorState(cookieValue);

    } else {

        Vendd.Service.call({
            url: 'CmsService.svc/InitVisitorState',
            data: null,
            onSuccess: function (res) {

                cookieValue = Cookies.get("VisitorState");
                if (res.success && cookieValue) {
                    LhApp.Function.checkAndUpdateVisitorState(cookieValue);
                }
            }
        });
    }
};

LhApp.Function.checkAndUpdateVisitorState = function (cookieValue) {

    if (cookieValue) {

        var oldUrl = window.location.href;
        var cookieValueAsUrl = "?" + cookieValue;

        $('body').removeClass('x-checking-visitor-state').removeAttr('x-checking-visitor-state');

        // 1. Checks to update cookie values from querystring
        var oldLanguageCode = LhApp.Function.QueryString.getValueOf("languageCode", cookieValueAsUrl).toLowerCase();
        var newLanguageCode = LhApp.Function.QueryString.getValueOf("lang", oldUrl).toLowerCase();

        if (newLanguageCode != '' && newLanguageCode != oldLanguageCode) {
            cookieValue = LhApp.Function.Url.setParameterValueOnUrl(cookieValueAsUrl, "languageCode", newLanguageCode).replace("?", "");
            Cookies.set("VisitorState", cookieValue, { secure: LhApp.Context.Request.IsSecure, samesite: 'Lax' });
            cookieValueAsUrl = "?" + cookieValue;
        }

        var oldCountryCode = LhApp.Function.QueryString.getValueOf("countryCode", cookieValueAsUrl).toLowerCase();
        var newCountryCode = LhApp.Function.QueryString.getValueOf("country", oldUrl).toLowerCase();

        if (newCountryCode != '' && newCountryCode != oldCountryCode) {
            cookieValue = LhApp.Function.Url.setParameterValueOnUrl(cookieValueAsUrl, "countryCode", newCountryCode).replace("?", "");
            Cookies.set("VisitorState", cookieValue, { secure: LhApp.Context.Request.IsSecure, samesite: 'Lax' });
            cookieValueAsUrl = "?" + cookieValue;
        }

        var oldCurrencyCode = LhApp.Function.QueryString.getValueOf("currencyCode", cookieValueAsUrl).toLowerCase();
        var newCurrencyCode = LhApp.Function.QueryString.getValueOf("currency", oldUrl).toLowerCase();

        if (newCurrencyCode != '' && newCurrencyCode != oldCurrencyCode) {
            cookieValue = LhApp.Function.Url.setParameterValueOnUrl(cookieValueAsUrl, "currencyCode", newCurrencyCode).replace("?", "");
            Cookies.set("VisitorState", cookieValue, { secure: LhApp.Context.Request.IsSecure, samesite: 'Lax' });
            cookieValueAsUrl = "?" + cookieValue;
        }
    }
};

LhApp.Function.hideExpandables = function (wrapper) {
    var $expandables = $('*[data-expandablecontainer].x-expanded:not(.x-loading)', $(wrapper));
    $expandables.each(function (i, item) {
        var $expandable = $(item);
        $expandable.removeClass('x-expanded');
        $('*[data-expandabletrigger="' + $expandable.data('expandablecontainer') + '"].x-open', $(wrapper)).removeClass('x-open');
    });
};

LhApp.Function.bindUndropables = function (wrapper) {
    var $wrapper = $(wrapper);

    var $undropableElements = $('*[data-undropable]', $wrapper);
    $undropableElements.on('drop', function (e) {
        if (typeof (e.preventDefault) === 'function')
            e.preventDefault();
    });
};

LhApp.Function.bindExpandables = function (wrapper) {
    var $wrapper = $(wrapper);

    var $expandableContainers = $('*[data-expandablecontainer]', $wrapper);
    $expandableContainers.click(function (e) {
        e.stopPropagation();
    });

    var $triggers = $('*[data-expandabletrigger]', $wrapper);
    $triggers.each(function (i, item) {
        var $trigger = $(item);

        var triggerValue = $trigger.data('expandabletrigger');
        var $expandableContainer = $('*[data-expandablecontainer="' + triggerValue + '"]', $wrapper);

        var $triggers = $('*[data-expandabletrigger="' + triggerValue + '"]', $wrapper);

        if ($expandableContainer.length > 0) {
            $triggers.unbind('click');
            $triggers.click(function (e) {
                e.preventDefault();
                e.stopPropagation();

                $('*[data-expandablecontainer].x-expanded').each(function (w, wItem) {
                    var wItemContainer = $(wItem).data('expandablecontainer');
                    if (wItemContainer != triggerValue) {
                        $(wItem).removeClass('x-expanded');
                        $('*[data-expandabletrigger="' + wItemContainer + '"].x-open').removeClass('x-open');
                    }
                });

                if ($expandableContainer.hasClass('x-expanded')) {
                    $expandableContainer.removeClass('x-expanded');
                    $triggers.removeClass('x-open');
                } else {
                    $expandableContainer.addClass('x-expanded');
                    $triggers.addClass('x-open');

                    EventManager.trigger('lazyload');
                }
            });
        }
    });
};

LhApp.Function.isButtonDisabled = function (buttonWrapper) {
    var isDisabled = false;

    if ($(buttonWrapper).get(0).tagName.toLowerCase() == 'input') {
        if ($(buttonWrapper).is(':disabled'))
            isDisabled = true;
    }
    else {
        var $internalButton = $(buttonWrapper).find('input:button');
        if ($internalButton.length > 0) {
            if ($internalButton.is(':disabled'))
                isDisabled = true;
        }
        else if ($(buttonWrapper).hasClass('x-disabled')) {
            isDisabled = true;
        }
    }

    return isDisabled;
};

LhApp.Function.bindHrefButtons = function (wrapper) {
    $('*[data-href]', $(wrapper)).click(function (e) {
        if (e !== undefined && typeof (e.preventDefault) == 'function')
            e.preventDefault();

        var isDisabled = LhApp.Function.isButtonDisabled(this);
        if (isDisabled) {
            e.preventDefault();
        }
        else {
            document.location = $(this).data('href');
        }
    });
};

LhApp.Function.bindScrollable = function (wrapper) {
    $('*[data-scroll-to]', $(wrapper)).click(function () {
        var $this = $(this),
            element = $this.data('scroll-to'), time = $this.data('scroll-time'), offset = $this.data('scroll-offset'),
            time = (typeof time == "undefined" || time == "") ? 600 : time,
            offset = (typeof offset == "undefined" || offset == "") ? -10 : offset;

        if (element == "")
            return;

        if (element == "top") {
            $('html, body').animate({
                scrollTop: 0
            }, time);
        }
        if (element == "bottom") {
            $('html, body').animate({
                scrollTop: $('body').height()
            }, time);
        }
        if ($(element).length > 0) {
            $('html, body').animate({
                scrollTop: $(element).offset().top + offset
            }, time);
        }
    });
};

LhApp.Function.bindLazyLoadableImages = function (wrapper) {

    var $selectedWrapper;
    if ($(wrapper).data('lazy-load-init')) {
        $selectedWrapper = $(wrapper);
    } else {
        $selectedWrapper = $('*[data-lazy-load-init]', $(wrapper));
    }

    $selectedWrapper.each(function (i, innerWrapper) {

        var $innerWrapper = $(innerWrapper);
        var $lazyLoadOptions = $('*[data-input="lazy-load-options"]', $innerWrapper);
        var initLazyLoad = $innerWrapper.data('lazy-load-init');

        if (initLazyLoad) {

            var opts = {};
            var defOptions = {
                effect: "fadeIn"
            };

            if ($lazyLoadOptions.length == 1) {
                $.extend(true, opts, defOptions, JSON.parse($lazyLoadOptions.val()));
            } else {
                $.extend(true, opts, defOptions);
            }

            var $images = $("img[data-lazyload]", $innerWrapper);
            if ($images.length > 0 && typeof $.fn.lazyload === "function") {
                $($images, $innerWrapper).lazyload(opts);
            }

        }

        if ($lazyLoadOptions.length > 0) {
            $lazyLoadOptions.remove();
        }

    });

    if ($.inArray('lazyload', EventManager.events) == -1) {
        EventManager.bind('lazyload', function () {
            $(window).trigger('lazyload');
        });
    }

};

LhApp.Function.PageTrackingRequest = function () {
    var url = decodeURIComponent(LhApp.Context.Request.RawUrl);
    var qstr = url.substring(url.indexOf('?') + 1);
    var dataItem = {
        querystring: qstr,
        cookie: document.cookie
    };

    Vendd.Service.call({
        url: 'MarkService.svc/PageTracking',
        data: { query: dataItem },
        onSuccess: function (res) {

            var cookies = res;
            for (var i = 0; i < cookies.length; i++) {
                document.cookie = cookies[i].Name + "=" + cookies[i].Value + "; expires=" + (new Date(cookies[i].Expires)).toUTCString() + "; path=" + cookies[i].Path;
            }
        }
    });
};

LhApp.Function.MailChimpEcommerce360Tracking = function (oId, cId, eId) {

    Vendd.Service.call({
        url: 'MarkService.svc/MailChimpEcommerce360Tracking',
        data: { orderId: oId, campaignId: cId, emailId: eId }
    });
};

LhApp.Function.applyExchangeRate = function (price) {
    return LhApp.Function.applyExchangeRateExtended(price, LhApp.Context.Currency.ExchangeRate);
};

LhApp.Function.applyExchangeRateExtended = function (price, rate) {
    return price * rate;
};

var RenderPrice = function (price) {
    return LhApp.Function.renderPriceExtended(price, false, ' ', '', '');
};

var RenderPriceExtended = function (price, isShopDefaultCurrency, separatorSymbol, prefixSymbol, suffixSymbol) {
    return LhApp.Function.renderPriceExtended(price, isShopDefaultCurrency, separatorSymbol, prefixSymbol, suffixSymbol);
};

LhApp.Function.renderPrice = function (price) {
    return LhApp.Function.renderPriceExtended(price, false, ' ', '', '');
};

LhApp.Function.renderPriceExtended = function (price, isShopDefaultCurrency, separatorSymbol, prefixSymbol, suffixSymbol) {

    var symbol = LhApp.Context.Currency.Symbol;
    var numberOfDigits = LhApp.Context.Currency.NumberOfDigits;
    var symbolShownFirst = LhApp.Context.Currency.SymbolShownFirst;
    var doShowSymbol = LhApp.Context.Currency.DoShowSymbol;

    if (isShopDefaultCurrency) {
        symbol = LhApp.Context.ShopDefaultCurrency.Symbol;
        numberOfDigits = LhApp.Context.ShopDefaultCurrency.NumberOfDigits;
        symbolShownFirst = LhApp.Context.ShopDefaultCurrency.SymbolShownFirst;
        doShowSymbol = LhApp.Context.ShopDefaultCurrency.DoShowSymbol;
    }

    var formatedPrice = price.toFixed(numberOfDigits).replace('.', ',');

    if (doShowSymbol) {
        if (!symbolShownFirst) {
            formatedPrice = formatedPrice + separatorSymbol + symbol;
        } else {
            formatedPrice = symbol + separatorSymbol + formatedPrice;
        }
    }

    if (prefixSymbol != '') {
        formatedPrice = prefixSymbol + separatorSymbol + formatedPrice;
    }

    if (suffixSymbol != '') {
        formatedPrice = formatedPrice + separatorSymbol + suffixSymbol;
    }

    return formatedPrice;
};

var RenderPointsPrice = function (pointsPrice) {
    return LhApp.Function.renderPointsPriceExtended(pointsPrice, ',', ' ', '', '');
};

var RenderPointsPriceExtended = function (pointsPrice, commaSymbol, separatorSymbol, prefixSymbol, suffixSymbol) {
    return LhApp.Function.renderPointsPriceExtended(pointsPrice, commaSymbol, prefixSymbol, suffixSymbol);
};

LhApp.Function.renderPointsPriceExtended = function (pointsPrice, commaSymbol, separatorSymbol, prefixSymbol, suffixSymbol) {

    if (suffixSymbol == '') {
        suffixSymbol = pointsPrice === 1 ? 'point' : 'points';
    }

    var innerSuffixSymbol = suffixSymbol.length > 1 ? ' ' + LhApp.Function.getText('Common:PointsPriceSymbol_' + suffixSymbol) : suffixSymbol;

    var formatedPrice = pointsPrice.toFixed(2).replace('.00', '').replace('.', commaSymbol);

    if (prefixSymbol != '') {
        formatedPrice = prefixSymbol + separatorSymbol + formatedPrice;
    }

    if (innerSuffixSymbol != '') {
        formatedPrice = formatedPrice + separatorSymbol + innerSuffixSymbol;
    }

    return formatedPrice;
};

LhApp.Function.validateClientModel = function (model) {
    if (!model) return false;

    if (!model.LangCode || model.LangCode != LhApp.Context.Language) return false;

    if (!model.CurrCode || model.CurrCode != LhApp.Context.Currency.Code) return false;

    return true;
}

var ReplacePrices = function (obj) {
    $('.x-product-box[data-productid]').each(function (i, el) {
        var itemId = parseInt($(el).attr('data-productid'));

        var itemData = obj.filter(function (a) { return a.Id === itemId })[0]

        var DeletedPrice = parseFloat(itemData.DeletedPrice);
        var Price = parseFloat(itemData.Price);
        var TotalPointsPrice = parseFloat(itemData.TotalPointsPrice);
        var TotalPointsGain = parseFloat(itemData.TotalPointsGain);
        var PointsPrice = parseFloat(itemData.PointsPrice);
        var PointsGain = parseFloat(itemData.PointsGain);

        // hide all
        $('.prices', el).addClass('hide');
        $('.deleted-price-container', el).addClass('hide');
        $('.current-price-container', el).addClass('hide');
        $('.current-point-price-container.1', el).addClass('hide');
        $('.current-point-price-container.2', el).addClass('hide');
        $('.current-point-price-container.3', el).addClass('hide');
        $('.current-point-price-container.4', el).addClass('hide');

        if (DeletedPrice > 0 || Price > 0 || TotalPointsPrice > 0 || TotalPointsGain > 0 || PointsPrice > 0 || PointsGain > 0) {
            $('.prices', el).removeClass('hide');

            if ((DeletedPrice > 0) && (DeletedPrice > Price)) {
                $('.deleted-price-container', el).removeClass('hide');
                $('.deleted-price', el).text(RenderPrice(itemData.DeletedPrice));
            }

            if (Price > 0) {
                $('.current-price-container', el).removeClass('hide');
                $('.current-price', el).text(RenderPrice(itemData.Price));
            }

            if (PointsPrice > 0 && PointsPrice != TotalPointsPrice) {
                $('.current-point-price-container.1', el).removeClass('hide');
                $('.current-point-price-container.1 .points-price', el).text(RenderPointsPrice(PointsPrice));
            }

            if (TotalPointsGain > 0) {
                $('.current-point-price-container.2', el).removeClass('hide');
                $('.current-point-price-container.2 .points-gain', el).text(RenderPointsPrice(TotalPointsGain));
            }

            if (PointsGain > 0 && TotalPointsGain === 0) {
                $('.current-point-price-container.3', el).removeClass('hide');
                $('.current-point-price-container.3 .points-gain', el).text(RenderPointsPrice(PointsGain));
            }

            if (TotalPointsPrice > 0) {
                $('.current-point-price-container.4', el).removeClass('hide');
                $('.current-point-price-container.4 .points-price', el).text(RenderPointsPrice(TotalPointsPrice));
            }
        }
    });
}

var ReplaceAvailabilities = function (obj) {
    $('.x-product-box[data-productid]').each(function (i, el) {
        var itemId = parseInt($(el).attr('data-productid'));
        var itemData = obj.filter(function (a) { return a.Id === itemId })[0]

        var cartEnabled = itemData.CanBuy === true || itemData.CanBuyWithPoints === true;
        var wishlistEnabled = itemData.CanAddToList === true;

        if ($('.buttons .add-to-cart').length > 0 && $('.buttons .add-to-cart input').length > 0) {
            $('.buttons .add-to-cart').addClass('x-disabled');
            $('.buttons .add-to-cart input').attr('disabled', 'disabled');

            if (cartEnabled === true) {
                $('.buttons .add-to-cart').removeClass('x-disabled');
                $('.buttons .add-to-cart input').removeAttr('disabled', 'disabled');
            }
        }

        //if ($('.buttons .add-to-wishlist').length > 0 && $('.buttons .add-to-wishlist input').length > 0) {
        //$('.buttons .add-to-wishlist').addClass('x-disabled');
        //$('.buttons .add-to-wishlist input').attr('disabled', 'disabled');

        //if (wishlistEnabled === true) {
        //$('.buttons .add-to-wishlist').removeClass('x-disabled');
        //$('.buttons .add-to-wishlist input').removeAttr('disabled', 'disabled');
        //}
        //}
    });
}

LhApp.Function.validateTaxIdentifier = function (isInvoice, countryCode, taxIdentifier) {
    if (isInvoice === true && taxIdentifier.length > 0) {
        if (countryCode === 'GR') {
            if (!isNaN(parseInt(taxIdentifier)) && taxIdentifier.length === 9) {
                var result = 0;
                var arrTaxId = taxIdentifier.split("").map(function (item) {
                    return parseInt(item);
                });

                for (var i = arrTaxId.length - 2; i >= 0 ; i--) {
                    result = result + arrTaxId[i] * Math.pow(2, (8 - i));
                }

                if ((result % 11) % 10 === arrTaxId[8]) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        else
            return true;
    }

    return false;
};

LhApp.pauseScroll = false;

LhApp.init = function () {

    LhApp.Function.bindScrollable($('body').get(0));
    LhApp.Function.bindExpandables($('body').get(0));
    LhApp.Function.bindHrefButtons($('body').get(0));
    LhApp.Function.bindUndropables($('body').get(0));
    //LhApp.Function.bindLazyLoadableImages($('body').get(0));  

    $('body').click(function (e) {
        LhApp.Function.hideExpandables(this);
    });

    $(document).scroll(function (e) {
        if (!LhApp.pauseScroll)
            LhApp.Function.hideExpandables($('body').get(0));
    });
};

var disqus_config = function () {

    if (LhApp.Context.Item.Id && LhApp.Context.Request.FriendlyUrl) {

        this.page.url = LhApp.Context.Request.BaseUrl + LhApp.Context.Request.FriendlyUrl;
        this.page.identifier = LhApp.Context.Item.Id;

    }
};

var replaceIframe = function (idFrame, url) {
    var originalFrame = document.getElementById(idFrame);
    var newFrame = document.createElement("iframe");
    newFrame.id = originalFrame.getAttribute("id");
    newFrame.width = originalFrame.getAttribute("width");
    newFrame.height = originalFrame.getAttribute("height");
    newFrame.style.display = "none";
    newFrame.src = url;
    var parent = originalFrame.parentNode;
    parent.replaceChild(newFrame, originalFrame);
};

var convertToGreek = function () {
    $("input[type='text'].js-convert-to-greek").keyup(function () {
        if ($(this).closest('.form-row').find('.js-disable-conversion').is(':checked')) return;
        var str = $(this).val().toUpperCase();
        var newstr = [];
        for (var i = 0, len = str.length; i < len; i++) {
            newstr[i] = convertCharacters(str[i]);
        }
        $(this).val(newstr.join(""));
        $(this).trigger("input"); //just to let angular know
    });
};

var convertToUppercase = function () {
    $("input[type='text'].js-convert-to-uppercase").keyup(function () {
        if ($(this).closest('.form-row').find('.js-disable-conversion').is(':checked')) return;
        //convert letter to uppercase
        var str = $(this).val().toUpperCase();
        //remove accents 
        str = str.replace(/Ά/g, 'Α')
            .replace(/Έ/g, 'Ε')
            .replace(/Ή/g, 'Η')
            .replace(/Ί/g, 'Ι')
            .replace(/Ό/g, 'Ο')
            .replace(/Ύ/g, 'Υ')
            .replace(/Ώ/g, 'Ω');

        $(this).val(str);
        $(this).trigger("input"); //just to let angular know
    });
};

var convertCharacters = function(character) {
    switch (character) {
        case "A":
            character = 'Α';
            break;
        case "B":
            character = 'Β';
            break;
        case "C":
            character = 'Ψ';
            break;
        case "D":
            character = 'Δ';
            break;
        case "E":
            character = 'Ε';
            break;
        case "F":
            character = 'Φ';
            break;
        case "G":
            character = 'Γ';
            break;
        case "H":
            character = 'Η';
            break;
        case "I":
            character = 'Ι';
            break;
        case "J":
            character = 'Ξ';
            break;
        case "K":
            character = 'Κ';
            break;
        case "L":
            character = 'Λ';
            break;
        case "M":
            character = 'Μ';
            break;
        case "N":
            character = 'Ν';
            break;
        case "O":
            character = 'Ο';
            break;
        case "P":
            character = 'Π';
            break;
        case "Q":
            character = 'Κ';
            break;
        case "R":
            character = 'Ρ';
            break;
        case "S":
            character = 'Σ';
            break;
        case "T":
            character = 'Τ';
            break;
        case "U":
            character = 'Θ';
            break;
        case "V":
            character = 'Ω';
            break;
        case "W":
            character = 'Σ';
            break;
        case "X":
            character = 'Χ';
            break;
        case "Y":
            character = 'Υ';
            break;
        case "Z":
            character = 'Ζ';
            break;
    }
    return character;
}

/* ------------- global functions for arrays ------------- */

//returns a copy sorted by the property copy of the array
var sortBy = function (array, property) {
    var sortedArray = [];

    sortedArray = array.sort(function (x, y) {
        return x[property] - y[property];
    });

    return sortedArray;
};

//flattens a nested array
var flatten = function (array, depth = 1) {
    var flatArray = [];

    for (var i = 0; i < array.length; i++) {
        if (Array.isArray(array[i]) && depth > 0) {
            flatArray.push.apply(flatArray, flatten(array[i], depth - 1));
        } else {
            flatArray.push(array[i]);
        }
    }

    return flatArray;
};

//returns a real array from the list
//useful for transmuting the arguments object
var toArray = function (list) {
    var array = [];

    Object.keys(list).forEach(function (key) {
        var value = list[key];

        if (Array.isArray(value))
            array.push(value);
    });

    return array;
};

//returns the values without the elements that the truth test passes
var reject = function (array, predicate) {
    var rejectedArray = [];

    for (var i = 0; i < array.length; i++) {
        var item = array[i];
        if (!predicate(item)) {
            rejectedArray.push(item);
        }
    }

    return rejectedArray;
};

//returns the values from array1 that are not present in array2
var difference = function (array1, array2) {
    var diffArray = [];

    for (var i = 0; i < array1.length; i++) {
        var item = array1[i];
        if (!array2.includes(item)) {
            diffArray.push(item);
        }
    }

    return diffArray;
};

//returns the unique values of the arrays
var union = function (arrays) {
    var unionArray = [];

    for (var i = 0; i < arrays.length; i++) {
        var array = arrays[i];
        for (var j = 0; j < array.length; j++) {
            var item = array[j];
            if (!unionArray.includes(item)) {
                unionArray.push(item);
            }
        }
    }

    return unionArray;
};

//returns the first occurrence of each value from an array
var uniq = function (array) {
    var uniqArray = [];

    uniqArray = array.filter(function (value, index) {
        return array.indexOf(value) === index
    });

    return uniqArray;
};

//returns the minimum value of the given property
var min = function (array, property) {
    var minVal = array.reduce(function (prev, curr) {
        return prev[property] < curr[property] ? prev : curr;
    });

    return minVal;
}

//returns the maximum value of the given property
var max = function (array, property) {
    var maxVal = array.reduce(function (prev, curr) {
        return prev[property] > curr[property] ? prev : curr;
    });

    return maxVal;
}

/* ------------- global functions for objects ------------- */

//returns a copy of the object, filtered to only have values for the given keys
var pick = function (object, keys) {
    var newObject = {};

    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (object.hasOwnProperty(key)) {
            newObject[key] = object[key];
        }
    }

    return newObject;
};

//returns a copy of the object, filtered to omit the disallowed key
var omit = function (object, key) {
    var newObject = {};

    for (var property in object) {
        if (property !== key) {
            newObject[property] = object[property];
        }
    }

    return newObject;
};

//returns a shallow-copied clone of the provided object or array
var clone = function (obj) {
    if (Array.isArray(obj)) {
        return obj.slice();
    } else if (typeof obj === 'object' && obj !== null) {
        return Object.assign({}, obj);
    } else {
        return obj;
    }
};